import { render, staticRenderFns } from "./BookingFollowups.vue?vue&type=template&id=7c020813&scoped=true"
import script from "./BookingFollowups.vue?vue&type=script&lang=js"
export * from "./BookingFollowups.vue?vue&type=script&lang=js"
import style0 from "./BookingFollowups.vue?vue&type=style&index=0&id=7c020813&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c020813",
  null
  
)

export default component.exports